import React from 'react';
import { registerWidget } from '../widgetRegistry';
import { useLayoutCtx } from '../LayoutContext';
import { StatusChanger } from '../../CaseClient';

// Granular Case-surface widget — exposes the case-type's status workflow
// transitions as a row of buttons. Wraps the existing StatusChanger
// component; on transition, calls the host's onCaseUpdated callback so the
// rest of the case detail re-renders with the new status.

function CaseStatusChanger() {
  const { token, workspaceId, case: caseRow, callbacks, bus } = useLayoutCtx();
  if (!caseRow) return null;
  const handleUpdated = (updated) => {
    const merged = { ...caseRow, ...updated };
    if (callbacks && typeof callbacks.onCaseUpdated === 'function') {
      callbacks.onCaseUpdated(merged);
    }
    if (bus && typeof bus.publish === 'function') {
      bus.publish('xv.CaseStatusChanged', { case: merged });
    }
  };
  return (
    <div style={{ padding: '10px 20px', borderBottom: '1px solid var(--border-color)', background: 'var(--bg-secondary)' }}>
      <StatusChanger token={token} workspaceId={workspaceId} caseRow={caseRow} onUpdated={handleUpdated} />
    </div>
  );
}

registerWidget({
  type: 'case.status_changer',
  categories: ['case'],
  palette_label: 'Status changer',
  description: 'Buttons to move the case to its allowed next statuses (driven by case_type.status_workflow_json).',
  Component: CaseStatusChanger,
  configSchema: null,
  publishes: ['xv.CaseStatusChanged'],
  subscribes: [],
  group: 'Case',
});
